import styled from "styled-components";
import Box from "../Box";
import { Colors } from "../../config/Constants";
import Textfield from "../Merchant/Textfield";
import Selectfield from "../Merchant/Selectfield";
import Button from "../Button";
import UploadPromoImages from "../ManagePromo/UploadPromoImages";
import TextArea from "../ManageParks/TextArea";
import countryCodeData from "../../pages/AddOutlet/countries";
import { StyledPageHeader } from "../Promotion/PromotionHeader";
import Timefield from "../Events/Timefield";
import Datefield from "../Events/Datefield";
import Radio from "./Radio";
import MultiselectDropdown from "../MultiselectDropdown";
import Toggle from "../Toggle";
import { StyledStatus } from "../../pages/ManagePromotion";
import InfoAndText from "../ManageOutlet/InfoAndText";
import { useEffect } from "react";
import Tag from "../Tag";
import TimeRangeSelector from "../TimeRange";
import { getWeekArray } from "../../helper";

interface StatusProps {
  status: boolean;
}

interface Props {
  onSubmit: () => void;
  onChange: (
    event:
      | React.ChangeEvent<HTMLInputElement>
      | React.ChangeEvent<HTMLSelectElement>
      | React.ChangeEvent<HTMLTextAreaElement>
      | any
  ) => void;
  onCancel: () => void;
  onRemove: () => void;
  onTagSelect: (val: any) => void;
  onParkChange: (
    event:
      | React.ChangeEvent<HTMLInputElement>
      | React.ChangeEvent<HTMLSelectElement>
      | React.ChangeEvent<HTMLTextAreaElement>
  ) => void;
  value: {
    code: string;
    title: string;
    description: string;
    isUnlimited: boolean;
    discountType: string;
    percentage: number | any;
    isPublic: boolean;
    startDate: string;
    endDate: string;
    // startTime: string;
    // endTime: string;
    outlet: string;
    products: any;
    imageUrl: string;
    showInApp: boolean;
    tag: any[];
    maxUseCount: any;
    countPerUser: any;
    maxQtyApplicable: any;
    freeProduct: string;
    isFreeProduct: boolean;
  };
  discounts: any[];
  error: {
    code: string;
    title: string;
    description: string;
    isUnlimited: string;
    discountType: string;
    percentage: string;
    isPublic: string;
    startDate: string;
    endDate: string;
    // startTime: string;
    // endTime: string;
    outlet: string;
    products: string;
    imageUrl: string;
    time: any;
    timeType: string;
    timeSingle: string;
    maxUseCount: any;
    countPerUser: any;
    maxQtyApplicable: any;
    freeProduct: string;
    isFreeProduct: string;
  };
  parks: any[];
  products: any[];
  onShowAppToggle: () => void;
  tagsList: any;
  onTimeSelect: any;
  time: any;
  timeType: any;
  timeSingle: any;
  onPromoTimeChange: any;
}

const AddPromoForm = ({
  onSubmit,
  onCancel,
  onChange,
  onRemove,
  value,
  error,
  parks,
  products,
  onParkChange,
  discounts,
  onShowAppToggle,
  onTagSelect,
  tagsList,
  onTimeSelect,
  time,
  timeType,
  timeSingle,
  onPromoTimeChange,
}: Props) => {
  let selectedDateWeekArray = getWeekArray(value.startDate, value.endDate);

  const getTagsList = () => {
    let tagListArray: { label: any; selected: boolean }[] = [];
    tagsList.forEach((list: any) => {
      tagListArray.push({
        label: list.key,
        selected: value?.tag?.includes(list.key),
      });
    });

    tagListArray.push({
      label: "none",
      selected: value?.tag?.length > 0 ? false : true,
    });
    return tagListArray;
  };

  const onTimeChange = (event: any, value: any, name: string) => {
    const newTime = value.replace(/-/g, ":");
    const timeVal = newTime.substr(0, 5);
    onTimeSelect(timeVal, event.target.name, name);
  };

  return (
    <Container>
      <Box>
        <FormWrapper>
          <FormRow>
            <FieldWrapper>
              <Selectfield
                name="discountType"
                label="Kind of Promocode"
                onChange={onChange}
                value={value.discountType}
                required
                helperText={error["discountType"]}
                // disabled={!value.outlet}
                data={discounts}
              />
            </FieldWrapper>
            <FieldWrapper>
              <Selectfield
                name="outlet"
                label="Select Park"
                onChange={onParkChange}
                value={value.outlet}
                required
                helperText={error["outlet"]}
                data={
                  value.discountType === "cart"
                    ? parks
                    : parks.filter((park) => park.value !== "all")
                }
                disabled={!value.discountType}
              />
            </FieldWrapper>
          </FormRow>
          {value.discountType === "product" && (
            <FormRow>
              <FieldWrapper>
                <Textfield
                  name="maxQtyApplicable"
                  label="Product Count"
                  onChange={onChange}
                  placeholder="Enter Product Count"
                  value={value.maxQtyApplicable}
                  required={false}
                  helperText={error["maxQtyApplicable"]}
                />
              </FieldWrapper>
              <FreeFieldWrapper>
                <Toggle
                  uniqueName={"isFreeProduct"}
                  isChecked={value.isFreeProduct}
                  onChange={() =>
                    onChange({
                      target: {
                        value: !value.isFreeProduct,
                        name: "isFreeProduct",
                      },
                    })
                  }
                />
                <span>Free Products Included</span>
              </FreeFieldWrapper>
            </FormRow>
          )}
          {value.discountType === "product" && (
            <FormRow>
              <FieldWrapper></FieldWrapper>
              <FieldWrapper>
                <Selectfield
                  name="freeProduct"
                  label="Select Free Product"
                  onChange={onChange}
                  value={value.freeProduct}
                  required={value.isFreeProduct}
                  disabled={value.isFreeProduct ? false : true}
                  helperText={error["freeProduct"]}
                  data={[
                    { value: "", label: "Select Free Product" },
                    ...products,
                  ]}
                />
              </FieldWrapper>
            </FormRow>
          )}
          <FormRow>
            <FieldWrapper>
              <Textfield
                name="code"
                label="Promocode"
                onChange={onChange}
                placeholder="Enter Promocode"
                value={value.code}
                required={false}
                helperText={error["code"]}
              />
            </FieldWrapper>
            <FieldWrapper>
              <Textfield
                type="number"
                name="percentage"
                label="Discount Percentage"
                onChange={onChange}
                placeholder="Enter Percentage"
                value={value.percentage}
                required={false}
                helperText={error["percentage"]}
                disabled={value.isFreeProduct}
              />
            </FieldWrapper>
          </FormRow>
          {/* <FormRow>
            <FieldWrapper>
              <Datefield
                name="startDate"
                label="Start Date"
                onChange={onChange}
                placeholder="Select date"
                value={value.startDate}
                required
                helperText={error["startDate"]}
              />
            </FieldWrapper>
            <FieldWrapper>
              <Datefield
                name="endDate"
                label="End Date"
                onChange={onChange}
                placeholder="Select date"
                value={value.endDate}
                required
                helperText={error["endDate"]}
              />
            </FieldWrapper>
          </FormRow> */}
          {/* <FormRow>
            <FieldWrapper>
              <Timefield
                name="startTime"
                label="Start Time"
                onChange={onChange}
                placeholder="Select time"
                value={value.startTime}
                helperText={error["startTime"]}
                disabled={
                  value.startDate ? value.startDate !== value.endDate : true
                }
              />
            </FieldWrapper>
            <FieldWrapper>
              <Timefield
                name="endTime"
                label="End Time"
                onChange={onChange}
                placeholder="Select time"
                value={value.endTime}
                helperText={error["endTime"]}
                disabled={
                  value.startDate ? value.startDate !== value.endDate : true
                }
              />
            </FieldWrapper>
          </FormRow> */}
          <FormRow>
            <FieldWrapper>
              <Textfield
                name="title"
                label="Promocode Title"
                onChange={onChange}
                placeholder="Enter Title"
                value={value.title}
                required={true}
                helperText={error["title"]}
              />
            </FieldWrapper>
            <FieldWrapper>
              <MultiselectDropdown
                name="products"
                label="Product ID for PromoCode"
                onChange={onChange}
                value={value.products}
                required={value.discountType === "product"}
                helperText={error["products"]}
                data={products}
                disabled={
                  value.outlet === "" ||
                  value.outlet === "all" ||
                  value.discountType === "cart"
                }
                placeholder="Select PromoCode"
              />
            </FieldWrapper>
          </FormRow>
          <FormRow>
            <FieldWrapper>
              <TextArea
                label="Information"
                placeholder="About"
                onChange={onChange}
                value={value.description}
                name="description"
                required
                helperText={error["description"]}
                rows={10}
              />
            </FieldWrapper>
            <FieldWrapper>
              {/* <Gap> */}
              <Label>Select Tags</Label>
              <TagWrapper>
                {getTagsList().map((item: any) => (
                  <Tag
                    item={item}
                    color={Colors.red}
                    onTagSelect={onTagSelect}
                  />
                ))}
              </TagWrapper>
              {/* </Gap> */}
            </FieldWrapper>
          </FormRow>
          <FormRow>
            <FieldWrapper>
              <Label>Types of Promocode{<span>*</span>}</Label>
              <RadioGroup>
                <Radio
                  label="Public"
                  selected={value.isPublic === true}
                  onClick={() =>
                    onChange({ target: { value: true, name: "isPublic" } })
                  }
                />
                <Radio
                  label="Private"
                  selected={value.isPublic === false}
                  onClick={() =>
                    onChange({ target: { value: false, name: "isPublic" } })
                  }
                />
              </RadioGroup>
            </FieldWrapper>
            <FieldWrapper>
              <Label>Access Plan</Label>
              <RadioGroup>
                <Radio
                  label="Unlimited"
                  selected={value.isUnlimited === true}
                  onClick={() =>
                    onChange({ target: { value: true, name: "isUnlimited" } })
                  }
                />
                <Radio
                  label="Limited"
                  selected={value.isUnlimited === false}
                  onClick={() =>
                    onChange({ target: { value: false, name: "isUnlimited" } })
                  }
                />
              </RadioGroup>
            </FieldWrapper>
          </FormRow>
          {!value.isUnlimited && (
            <div>
              <span style={{ fontSize: "0.8rem" }}>
                Count of Promotion to be used (0 is unlimited)
              </span>
              <FormRow>
                <FieldWrapper>
                  <Textfield
                    name="maxUseCount"
                    label="Max Use Count"
                    onChange={onChange}
                    placeholder="Enter Maximum use count"
                    value={value.maxUseCount}
                    helperText={error["maxUseCount"]}
                  />
                </FieldWrapper>
                <FieldWrapper>
                  <Textfield
                    name="countPerUser"
                    label="Count Per User"
                    onChange={onChange}
                    placeholder="Enter Count per user"
                    value={value.countPerUser}
                    helperText={error["countPerUser"]}
                  />
                </FieldWrapper>
              </FormRow>
            </div>
          )}
        </FormWrapper>
      </Box>
      <Divider />
      <StyledPageHeader>{"Promocode Duration"}</StyledPageHeader>
      <Box>
        {parks?.filter((park) => park?.value === value?.outlet)[0]?.hours && (
          <div style={{ fontSize: "0.8rem", paddingBottom: "1rem" }}>
            <span>Work Time of selected park</span>
            {
              <HelperText>
                {Object.keys(
                  parks?.filter((park) => park?.value === value?.outlet)[0]
                    ?.hours
                ).map((keys) => (
                  <WorkingHours>
                    <span>{keys}</span> :
                    <span>
                      {
                        parks?.filter(
                          (park) => park?.value === value?.outlet
                        )[0]?.hours[keys]
                      }
                    </span>
                  </WorkingHours>
                ))}
              </HelperText>
            }
          </div>
        )}
        <FormWrapper>
          <FormRow>
            <FieldWrapper>
              <Datefield
                name="startDate"
                label="Start Date"
                onChange={onChange}
                placeholder="Select date"
                value={value.startDate}
                required
                helperText={error["startDate"]}
              />
            </FieldWrapper>
            <FieldWrapper>
              <Datefield
                name="endDate"
                label="End Date"
                onChange={onChange}
                placeholder="Select date"
                value={value.endDate}
                required
                helperText={error["endDate"]}
              />
            </FieldWrapper>
          </FormRow>
          <FormRow>
            <FieldWrapper>
              <Selectfield
                name="type"
                label="Timing"
                onChange={onPromoTimeChange}
                value={timeType}
                required
                helperText={error["timeType"]}
                data={[
                  { label: "Select Timing", value: "" },
                  { label: "Single Time", value: "single" },
                  { label: "Multi Time", value: "multi" },
                ]}
              />
            </FieldWrapper>
            <FieldWrapper>
              <TimeRangeSelector
                name="timeSingle"
                label="Sun to Sat"
                placeholder="Sun to Sat"
                onTimeChange={(e, val) => onTimeChange(e, val, "timeSingle")}
                value={timeType === "multi" ? "" : timeSingle}
                required={timeType === "single"}
                disabled={!timeType || timeType === "multi"}
                helperText={error["timeSingle"]}
                fullWidth
              />
            </FieldWrapper>
          </FormRow>
          <FormRow>
            <TimeWrapper>
              <TimeRangeSelector
                name="mon"
                label="Mon"
                placeholder="Monday"
                onTimeChange={(e, val) => onTimeChange(e, val, "mon")}
                value={
                  selectedDateWeekArray.indexOf("mon") < 0 ? "" : time["mon"]
                }
                required={false}
                disabled={
                  !timeType ||
                  timeType === "single" ||
                  selectedDateWeekArray.indexOf("mon") < 0
                }
                helperText={error?.time["mon"]}
              />
              <TimeRangeSelector
                name="tue"
                label="Tue"
                placeholder="Tuesday"
                onTimeChange={(e, val) => onTimeChange(e, val, "tue")}
                value={
                  selectedDateWeekArray.indexOf("tue") < 0 ? "" : time["tue"]
                }
                required={false}
                disabled={
                  !timeType ||
                  timeType === "single" ||
                  selectedDateWeekArray.indexOf("tue") < 0
                }
                helperText={error?.time["tue"]}
              />
              <TimeRangeSelector
                name="wed"
                label="Wed"
                placeholder="Wednesday"
                onTimeChange={(e, val) => onTimeChange(e, val, "wed")}
                value={
                  selectedDateWeekArray.indexOf("wed") < 0 ? "" : time["wed"]
                }
                required={false}
                disabled={
                  !timeType ||
                  timeType === "single" ||
                  selectedDateWeekArray.indexOf("wed") < 0
                }
                helperText={error?.time["wed"]}
              />
              <TimeRangeSelector
                name="thu"
                label="Thu"
                placeholder="Thursday"
                onTimeChange={(e, val) => onTimeChange(e, val, "thu")}
                value={
                  selectedDateWeekArray.indexOf("thu") < 0 ? "" : time["thu"]
                }
                required={false}
                disabled={
                  !timeType ||
                  timeType === "single" ||
                  selectedDateWeekArray.indexOf("thu") < 0
                }
                helperText={error?.time["thu"]}
              />
              <TimeRangeSelector
                name="fri"
                label="Fri"
                placeholder="Friday"
                onTimeChange={(e, val) => onTimeChange(e, val, "fri")}
                value={
                  selectedDateWeekArray.indexOf("fri") < 0 ? "" : time["fri"]
                }
                required={false}
                disabled={
                  !timeType ||
                  timeType === "single" ||
                  selectedDateWeekArray.indexOf("fri") < 0
                }
                helperText={error?.time["fri"]}
              />
              <TimeRangeSelector
                name="sat"
                label="Sat"
                placeholder="Saturday"
                onTimeChange={(e, val) => onTimeChange(e, val, "sat")}
                value={
                  selectedDateWeekArray.indexOf("sat") < 0 ? "" : time["sat"]
                }
                required={false}
                disabled={
                  !timeType ||
                  timeType === "single" ||
                  selectedDateWeekArray.indexOf("sat") < 0
                }
                helperText={error?.time["sat"]}
              />
              <TimeRangeSelector
                name="sun"
                label="Sun"
                placeholder="Sunday"
                onTimeChange={(e, val) => onTimeChange(e, val, "sun")}
                value={
                  selectedDateWeekArray.indexOf("sun") < 0 ? "" : time["sun"]
                }
                required={false}
                disabled={
                  !timeType ||
                  timeType === "single" ||
                  selectedDateWeekArray.indexOf("sun") < 0
                }
                helperText={error?.time["sun"]}
              />
            </TimeWrapper>
          </FormRow>
        </FormWrapper>
      </Box>
      <Divider />
      <SpecialOfferHeader>
        <SpecialOfferHeaderText>{"Special Offer"}</SpecialOfferHeaderText>
        <FormWrapper>
          <FormRow>
            <InfoWrapper>
              <InfoAndText text="(This toggle is to Enable and Disable the visibility of Special Offer Image)" />
              <StyledStatus>
                <div style={{ display: "flex", alignItems: "center" }}>
                  Status:
                  <ActiveDeactive status={!value?.showInApp}>
                    {"Disable"}
                  </ActiveDeactive>
                  <Toggle
                    uniqueName={"showInApp"}
                    isChecked={value?.showInApp}
                    onChange={onShowAppToggle}
                  />
                  <ActiveDeactive status={value?.showInApp}>
                    {"Enable"}
                  </ActiveDeactive>
                </div>
              </StyledStatus>
            </InfoWrapper>
          </FormRow>
        </FormWrapper>
      </SpecialOfferHeader>
      <Box>
        <FormWrapper>
          <FormRow>
            <FieldWrapper>
              <UploadPromoImages
                name="imageUrl"
                label="Upload Offer image"
                onChange={onChange}
                onRemove={onRemove}
                required
                helperText={error["imageUrl"]}
                maxImages={1}
                subLabel="Only JPEG or PNG files are allowed. Max size: 2MB. Recommended dimensions: 327 x 106."
                urls={value.imageUrl}
                acceptFormats=".jpeg, .jpg, .png"
              />
            </FieldWrapper>
          </FormRow>
        </FormWrapper>
      </Box>
      <ImageHelperText>
        Enabling the toggle switch mandates the upload of an image.
      </ImageHelperText>
      <ActionRow>
        <ButtonWrapper>
          <Button
            variant="outlined"
            label="Cancel"
            onClick={onCancel}
            width="9.7rem"
          />
          <Button
            color={Colors.red}
            variant="filled"
            label="Save"
            onClick={onSubmit}
            width="9.7rem"
          />
        </ButtonWrapper>
      </ActionRow>
    </Container>
  );
};

interface GapProps {
  height: string;
  height2?: string;
}

const ImageHelperText = styled.div`
  font-size: 0.8rem;
  font-family: "Poppins-Medium";
  color: ${Colors.cloudyGrey};
  padding: 0 1.5rem;
`;

const TimeWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  justify-content: space-between;
  @media only screen and (max-width: 768px) {
    flex: 1;
  }
`;

const SpecialOfferHeaderText = styled.div`
  font-size: 1.25rem;
  font-family: "Poppins-Medium";
  line-height: 1.75rem;
  color: ${Colors.black};
  font-weight: 500;
  padding: 0 1.5rem;
  padding-bottom: 1rem;
`;

const SpecialOfferHeader = styled.div`
  display: flex;
  justify-content: space-between;
  @media only screen and (max-width: 768px) {
    flex-direction: column;
  }
`;

const WorkingHours = styled.div`
  display: flex;
  margin-right: 1rem;
`;
const HelperText = styled.span`
  font-size: 0.75rem;
  color: grey;
  display: flex;
  > div > span {
    text-transform: uppercase;
  }
  @media only screen and (max-width: 768px) {
    flex-direction: column;
    > div {
      margin: 0.25rem 0;
    }
  }
`;

const TagWrapper = styled.div`
  display: flex;
  gap: 0.25rem;
  margin-top: 0.25rem;
  flex-wrap: wrap;
`;
const Label = styled.label`
  font-family: "Poppins-Medium";
  font-style: normal;
  font-weight: 350;
  font-size: 12px;
  line-height: 16px;
  color: ${Colors.electricBlue};
  margin-bottom: 1rem;
  > span {
    color: ${Colors.red};
    margin-left: 2px;
  }
`;

const RadioGroup = styled.div`
  display: flex;
  gap: 2rem;
  padding: 0.5rem 0;
`;

const FieldWrapper = styled.div`
  flex: 1;
  @media only screen and (max-width: 768px) {
    margin-top: 0.5rem;
  }
`;

const FreeFieldWrapper = styled.div`
  flex: 1;
  padding-top: 24px;
  display: flex;
  align-items: center;
  justify-content: start;
  gap: 8px;
  > span {
    font-size: 14px;
  }
  @media only screen and (max-width: 768px) {
    margin-top: 0.5rem;
  }
`;

const InfoWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  justify-content: flex-end;
  width: 100%;
  box-sizing: border-box;
  @media only screen and (max-width: 768px) {
    padding: 0 1.5rem;
    flex-direction: column-reverse;
    align-items: flex-start;
  }
`;

const ButtonWrapper = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-end;
  gap: 1.5rem;
  @media only screen and (max-width: 768px) {
    gap: 0.5rem;
    margin-top: 2rem;
    justify-content: center;
  }
  @media only screen and (max-width: 350px) {
    flex-direction: column-reverse;
    align-items: center;
  }
`;

const ActionRow = styled.div`
  display: flex;
  gap: 0.5rem;
  margin-top: 1rem;
`;

const FormRow = styled.div`
  display: flex;
  gap: 0.5rem;
  @media only screen and (max-width: 768px) {
    flex-direction: column;
  }
`;

const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  @media only screen and (max-width: 768px) {
    gap: 0.5rem;
  }
`;

const Container = styled.div`
  margin-top: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  @media only screen and (max-width: 768px) {
    margin-top: 0.5rem;
  }
`;
const Gap = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  @media only screen and (max-width: 768px) {
    gap: 1rem;
  }
`;
const Divider = styled.div`
  padding: 0.5rem 0;
  @media only screen and (max-width: 768px) {
    padding: 0;
    display: none;
  }
`;

export const ActiveDeactive = styled.div<StatusProps>`
  color: ${(props) => (props.status ? Colors.appleGreen : Colors.cloudyGrey)};
  margin: 0 0.5rem;
`;

export default AddPromoForm;
